module.exports = __webpack_public_path__ + "static/media/Brandon_bld.ea361e85.woff";